import { render, staticRenderFns } from "./businessApproval.vue?vue&type=template&id=6a38e622&scoped=true"
import script from "./businessApproval.vue?vue&type=script&lang=js"
export * from "./businessApproval.vue?vue&type=script&lang=js"
import style0 from "./businessApproval.vue?vue&type=style&index=0&id=6a38e622&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38e622",
  null
  
)

export default component.exports